import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from "@angular/core";
import {UserDataService} from "../services/user-data.service";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenOpt = inject(UserDataService).getAccessToken()
  if (tokenOpt) {
    // Отдел Adults / Kids заголовком не шлём: nginx отвечает на CORS-preflight сам и X-Department не пропускает
    // (браузер падал с «Нет связи с сервером»). Сервер берёт отдел, сохранённый переключателем (PUT /user/department).
    req = req.clone({setHeaders: {Authorization: `Bearer ${tokenOpt}`}});
  }
  return next(req);
};
